import React from 'react';

const year = new Date().getFullYear();

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <p>&copy; ErgZone {year}. All Rights Reserved.</p>
        <ul className="list-inline">
          <li className="list-inline-item">
            <a href="/privacy">Privacy</a>
          </li>
          <li className="list-inline-item">
            <a href="/terms">Terms</a>
          </li>
          <li className="list-inline-item">
            <a href="/faq">FAQ</a>
          </li>
        </ul>
      </div>
    </footer>
  );
}
